export enum ErrorCodes {
  ClientNotFound = 'ClientNotFound',
  InvalidPin = 'InvalidPin'
}